import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import SectionPanel from 'components/organisms/SectionPanels/SectionPanel/SectionPanel';

const StyledTaskSectionPanel = styled(SectionPanel)`
  .SectionPanel {
    &-panel {
      background-color: ${props => props.theme.property(`palette.primary.states.hover`)};
    }
  }
  
  ${ComponentStyles}
`;

StyledTaskSectionPanel.propTypes = {
  theme: PropTypes.object
};

export default StyledTaskSectionPanel;
